import { module } from 'angular';
import component from './code-editor.component';

export default module('app.code-editor', [])
	.component('codeEditor', component)
	.name;
